import {
  Backdrop,
  Box,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import { useState } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import moment from "moment";
import { nanoid } from "nanoid";

const daysOfWeek = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const UserTable = (props: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const userDetailWithIds = props?.getData?.map((userDetail: any) => ({
    ...userDetail,
    userId: nanoid(),
  }));

  return (
    <>
      {props?.getData?.length > 0 && (
        <Box sx={{ marginBottom: "20px" }}>
          <Typography
            variant="h6"
            sx={{ paddingX: "10px" }}
            className={globalClasses.typography}
          >
            Added Users
          </Typography>

          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#006699" }}>
                  <TableCell padding="checkbox" />

                  <TableCell
                    sx={{
                      color: "white",
                      padding: "12px",
                      borderBottom: "none",
                    }}
                  >
                    Username
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Clinic Type
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Clinic Location
                  </TableCell>

                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Edit
                  </TableCell>
                  <TableCell sx={{ color: "white", padding: "12px" }}>
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userDetailWithIds.map((userDetail: any, index: any) => (
                  <ExpandableTableRow
                    key={userDetail.userId}
                    userdetail={userDetail}
                  >
                    <TableCell sx={{ borderBottom: "none" }}>
                      {userDetail.userName}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      {userDetail.clinicType.split("@~@@").pop()}
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      {userDetail.clinicLocation.split("@~@@").pop()}
                    </TableCell>

                    <TableCell sx={{ borderBottom: "none" }}>
                      <IconButton
                        size="small"
                        onClick={(event: any) => {
                          setIsLoading(true);
                          setTimeout(() => {
                            props.setData(userDetail, index);
                            setIsLoading(false);
                          }, 500);
                        }}
                      >
                        <BorderColorIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{ borderBottom: "none" }}>
                      <IconButton
                        size="medium"
                        onClick={(event: any) => {
                          setIsDeleting(true);
                          setTimeout(() => {
                            props.deleteUser(event, index);
                            setIsDeleting(false);
                          }, 500);
                        }}
                      >
                        <DeleteForeverOutlinedIcon color="error" />
                      </IconButton>
                    </TableCell>
                  </ExpandableTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {isLoading && (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: 1500,
                display: "flex",
                flexDirection: "column",
              }}
              open
            >
              <Typography fontWeight="600" fontSize="20px">
                Editing Hp Schedule Information...!
              </Typography>
              <CircularProgress color="primary" sx={{ margin: "20px" }} />
            </Backdrop>
          )}
          {isDeleting && (
            <Backdrop
              sx={{
                color: "#fff",
                zIndex: 1500,
                display: "flex",
                flexDirection: "column",
              }}
              open
            >
              <Typography fontWeight="600" fontSize="20px">
                Deleting Hp Schedule...!
              </Typography>
              <CircularProgress color="primary" sx={{ margin: "20px" }} />
            </Backdrop>
          )}
        </Box>
      )}
    </>
  );
};

export default UserTable;

const ExpandableTableRow = (props: any) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <TableRow {...props}>
        <TableCell padding="checkbox" sx={{ borderBottom: "none" }}>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {props.children}
      </TableRow>
      <TableRow sx={{ border: "none" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <TableContainer component={Paper} sx={{ marginBottom: "10px" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#EBF1F7" }}>
                    {daysOfWeek.map((day) => (
                      <TableCell align="center" key={day}>
                        {day.charAt(0).toUpperCase() + day.slice(1)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    {daysOfWeek.map((day) => (
                      <TableCell align="center" key={day}>
                        {props?.userdetail?.[day]?.map((element: any) => (
                          <Typography
                            fontSize={"0.875rem"}
                            fontWeight={400}
                            key={nanoid()}
                          >
                            {element?.startTime && element?.endTime
                              ? moment(element?.startTime).format("HH:mm") +
                                "-" +
                                moment(element?.endTime).format("HH:mm")
                              : "On leave"}
                          </Typography>
                        ))}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
